const DAY_MS = 24 * 60 * 60 * 1000

const startOfDay = (d: Date) => new Date(d.getFullYear(), d.getMonth(), d.getDate())

const dayDiff = (from: Date, to: Date) => Math.round((startOfDay(to).getTime() - startOfDay(from).getTime()) / DAY_MS)

const dayLabel = (diff: number) => {
  if (diff === 0) return ''
  if (diff === 1) return '翌'
  if (diff === -1) return '前日'
  return diff > 0 ? `${diff}日後 ` : `${-diff}日前 `
}

/** 日をまたぐか (ちょうど翌 0:00 終了はまたがない扱い) */
export const isCrossDay = (start: Date, end: Date) => dayDiff(start, new Date(end.getTime() - 1)) !== 0

/** viewDate の日から見た「翌」「前日」付きの開始・終了時刻 */
export const formatCrossDayRange = (start: Date, end: Date, viewDate: Date, fmt: (d: Date) => string) => ({
  start: `${dayLabel(dayDiff(viewDate, start))}${fmt(start)}`,
  end: `${dayLabel(dayDiff(viewDate, end))}${fmt(end)}`,
})
